export default "__VITE_ASSET__CjNCxHr1__"